import { render, staticRenderFns } from "./MoreActivities.vue?vue&type=template&id=6db5a721&scoped=true&"
import script from "./MoreActivities.vue?vue&type=script&lang=js&"
export * from "./MoreActivities.vue?vue&type=script&lang=js&"
import style0 from "./MoreActivities.vue?vue&type=style&index=0&id=6db5a721&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6db5a721",
  null
  
)

export default component.exports